<template>
    <section class="Tracking" v-if="lang">
        <div class="search">
            <h1>{{translate.pages.tracking.subtitle}}</h1>
            <md-layout md-gutter>
                <md-layout md-flex="100" class="container">
                    <md-input-container :class="{ 'md-input-invalid' : errors.office.invalid }">
                        <label>{{translate.pages.tracking.index.fields.office}}</label>
                        <md-select name="office" id="office" v-model="data.office" :disabled="disabledOffice" required>
                            <md-option value="">{{translate.pages.tracking.index.fields.all_offices}}</md-option>
                            <md-option v-for="office in offices" :value="office.id" :key="office.id">{{ office.name }}</md-option>
                        </md-select>
                        <span class="md-error" v-if="errors.office.invalid">{{ errors.office.msg }}</span>
                    </md-input-container>
                </md-layout>
                <md-layout md-flex-small="100" md-flex="50" class="container">
                    <md-input-container :class="{ 'md-input-invalid' : errors.rut.invalid }">
                        <label>{{translate.pages.tracking.index.fields.patient_code}}</label>
                        <md-input type="text" v-model="data.rut"></md-input>
                        <span class="md-error" v-if="errors.rut.invalid">{{ errors.rut.msg }}</span>
                    </md-input-container>
                    <span class="suggestion">{{translate.pages.tracking.index.fields.patient_code_label}}</span>
                </md-layout>
                <md-layout md-flex-small="100" md-flex="50" class="container">
                    <md-input-container :class="{ 'md-input-invalid' : errors.name.invalid }">
                        <label>{{translate.pages.tracking.index.fields.patient_name}}</label>
                        <md-input type="text" v-model="data.name"></md-input>
                        <span class="md-error" v-if="errors.name.invalid">{{ errors.name.msg }}</span>
                    </md-input-container>
                    <span class="suggestion">{{translate.pages.tracking.index.fields.patient_name_label}}</span>
                </md-layout>
                <md-layout md-flex-small="100" md-flex="50" class="amolpicker container-date">
                    <label>{{translate.pages.tracking.index.fields.start_date}}</label>
                    <md-icon class="icon-calendar">today</md-icon>
                    <date-picker :option="option" class="picker" :date="startDate" v-model="data.start_date"></date-picker>
                    <small class="small-error" v-if="errors.start_date.invalid">{{ errors.start_date.msg }}</small>
                    <span class="suggestion diary" style="font-size: 0.85em">{{translate.pages.tracking.index.fields.dates_label}}</span>
                </md-layout>
                <md-layout md-flex-small="100" md-flex="50" class="amolpicker container-date">
                    <label>{{translate.pages.tracking.index.fields.end_date}}</label>
                    <md-icon class="icon-calendar">today</md-icon>
                    <date-picker :option="option" class="picker" :date="endDate" v-model="data.end_date"></date-picker>
                    <span class="span-error" v-if="errors.end_date.invalid">{{ errors.end_date.msg }}</span>
                    <span class="suggestion">&nbsp;</span>
                </md-layout>
                <hr class="divider">
                <md-layout md-flex="100" class="container button-search clearfix">
                    <md-button @click.native="search" class="md-raised md-primary md-size btn--blue" :disabled="process">
                        {{translate.pages.tracking.index.fields.search}}
                        <md-icon>search</md-icon>
                    </md-button>
                </md-layout>
            </md-layout>
        </div>
        <div class="result" v-if="response.success">
            <br>
            <h2>{{translate.pages.tracking.index.fields.result_subtitle}}</h2>
            <div class="search">
                <p class="not-found mini-found" v-if="!response.data.length">{{translate.pages.tracking.index.fields.result_not_found}}</p>
                <div v-else class="table table--office table-mobile table--tracking has-status">
                    <md-table md-sort="name" @sort="onSort" md-sort-by="name" class="table--wrap">
                        <md-table-header>
                            <md-table-row>
                                <md-table-head class="td-sort-name">{{translate.pages.tracking.index.fields.table.name}}</md-table-head>
                                <md-table-head md-sort-by="fecha">{{translate.pages.tracking.index.fields.table.date}}</md-table-head>
                                <md-table-head md-sort-by="office_id">{{translate.pages.tracking.index.fields.table.office_id}}</md-table-head>
                                <md-table-head md-sort-by="status" class="text-center hidden-mobile">{{translate.pages.tracking.index.fields.table.status}}</md-table-head>
                                <md-table-head class="text-center hidden-mobile">{{translate.pages.tracking.index.fields.table.actions}}</md-table-head>
                            </md-table-row>
                        </md-table-header>
                        <md-table-body>
                            <md-table-row v-for="(row, rowIndex) in response.data" :key="rowIndex" :md-item="row">
                                <md-table-cell class="name--cell">
                                    <div class="img">
                                        <img :src="srcImage(row.patient.image)">
                                    </div>
                                    <span class="name">{{ row.patient.name }} {{ row.patient.lastname }}</span>
                                    <span class="subname visible-mobile">{{ row.office.street }} {{ row.office.number }}</span>
                                </md-table-cell>
                                <md-table-cell class="tracking-date">
                                    <label class="visible-mobile">{{translate.pages.tracking.index.fields.table.date}}</label>
                                    <span>{{ row.fecha | formatTimeStamp }}</span>
                                </md-table-cell>
                                <md-table-cell class="hidden-mobile">
                                    <span>{{ row.office.name }}</span>
                                </md-table-cell>
                                <md-table-cell class="static-mobile">
                                    <div class="enabled" :class="{ 'active' : row.status }">{{ row.status | formatStatus }}</div>
                                </md-table-cell>
                                <md-table-cell class="actions">
                                    <md-icon class="icon-view raised" @click.native="openDialog('view', row, rowIndex)">chrome_reader_mode</md-icon>
                                    <md-icon class="icon-edit raised" @click.native="openDialog('edit', row, rowIndex)">edit</md-icon>
                                    <md-icon class="icon-delete raised" @click.native="remove(row, rowIndex)">delete</md-icon>
                                </md-table-cell>
                            </md-table-row>
                        </md-table-body>
                    </md-table>
                </div>
                <md-dialog md-open-from="#custom" md-close-to="#custom" ref="view">
                    <md-dialog-content>
                        <h3 class="dialog--title">{{translate.pages.tracking.index.fields.information_patient.title}}</h3>
                        <hr>
                        <div class="content-main">
                            <md-layout md-gutter class="modal-wrap">
                                <md-layout md-flex-small="100" md-flex="50" class="container">
                                    <md-input-container>
                                        <label>{{translate.pages.tracking.index.fields.information_patient.rut}}</label>
                                        <md-input type="text" v-model="response.currentDiary.patient.code" readonly></md-input>
                                    </md-input-container>
                                </md-layout>
                                <md-layout md-flex-small="100" md-flex="50" class="container">
                                    <md-input-container>
                                        <label>{{translate.pages.tracking.index.fields.information_patient.name}}</label>
                                        <md-input type="text" v-model="response.currentDiary.patient.name" readonly></md-input>
                                    </md-input-container>
                                </md-layout>
                                <md-layout md-flex-small="100" md-flex="50" class="container">
                                    <md-input-container>
                                        <label>{{translate.pages.tracking.index.fields.information_patient.lastname}}</label>
                                        <md-input type="text" v-model="response.currentDiary.patient.lastname" readonly></md-input>
                                    </md-input-container>
                                </md-layout>
                                <md-layout md-flex-small="100" md-flex="50" class="container">
                                    <md-input-container>
                                        <label>{{translate.pages.tracking.index.fields.information_patient.lastname2}}</label>
                                        <md-input type="text" v-model="response.currentDiary.patient.lastname2" readonly></md-input>
                                    </md-input-container>
                                </md-layout>
                                <md-layout md-flex-small="100" md-flex="50" class="container">
                                    <md-input-container>
                                        <label>{{translate.pages.tracking.index.fields.information_patient.phone}}</label>
                                        <md-input type="text" v-model="response.currentDiary.patient.phone" readonly></md-input>
                                    </md-input-container>
                                </md-layout>
                                <md-layout md-flex-small="100" md-flex="50" class="container">
                                    <md-input-container>
                                        <label>{{translate.pages.tracking.index.fields.information_patient.email}}</label>
                                        <md-input type="text" v-model="response.currentDiary.patient.email" readonly></md-input>
                                    </md-input-container>
                                </md-layout>
                            </md-layout>
                        </div>
                    </md-dialog-content>
                    <md-dialog-actions class="modal--footer">
                        <md-button class="md-primary md-size sm-size float-r" @click.native="closeDialog('view')">{{translate.pages.tracking.index.fields.information_patient.close}}</md-button>
                    </md-dialog-actions>
                </md-dialog>
                <md-dialog md-open-from="#custom" md-close-to="#custom" ref="edit"
                    :md-click-outside-to-close="response.close"
                    :md-esc-to-close="response.close">
                    <md-dialog-content>
                        <h3 class="dialog--title">{{translate.pages.tracking.edit.title}}</h3>
                        <hr>
                        <div class="content-main">
                            <md-layout md-gutter class="modal-wrap">
                                <md-layout md-flex-small="100" md-flex="50" class="container">
                                    <md-input-container>
                                        <label>{{translate.pages.tracking.edit.fields.office}}</label>
                                        <md-input type="text" v-model="response.currentDiary.office.name" readonly></md-input>
                                    </md-input-container>
                                </md-layout>
                                <md-layout md-flex-small="100" md-flex="50" class="container">
                                    <md-input-container>
                                        <label>{{translate.pages.tracking.edit.fields.code}}</label>
                                        <md-input type="text" v-model="response.currentDiary.patient.code" readonly></md-input>
                                    </md-input-container>
                                </md-layout>
                                <md-layout md-flex="100" class="patient">
                                    <md-layout md-flex="100" class="wrapper">
                                        <md-layout md-flex-small="100" md-flex="50" class="container">
                                            <md-input-container>
                                                <label>{{translate.pages.tracking.edit.fields.name}}</label>
                                                <md-input type="text" v-model="response.currentDiary.patient.name" readonly></md-input>
                                            </md-input-container>
                                        </md-layout>
                                        <md-layout md-flex-small="100" md-flex="50" class="container">
                                            <md-input-container>
                                                <label>{{translate.pages.tracking.edit.fields.email}}</label>
                                                <md-input type="text" v-model="response.currentDiary.patient.email" readonly></md-input>
                                            </md-input-container>
                                        </md-layout>
                                        <md-layout md-flex-small="100" md-flex="50" class="container">
                                            <md-input-container>
                                                <label>{{translate.pages.tracking.edit.fields.phone}}</label>
                                                <md-input type="text" v-model="response.currentDiary.patient.phone" readonly></md-input>
                                            </md-input-container>
                                        </md-layout>
                                    </md-layout>
                                </md-layout>
                                <md-layout md-flex-small="100" md-flex="50" class="amolpicker container-date">
                                    <label>{{translate.pages.tracking.edit.fields.date}}</label>
                                    <md-icon class="icon-calendar">today</md-icon>
                                    <date-picker :option="option" :limit="limit" class="picker" :date="currentDate" v-model="response.currentDiary.fecha"></date-picker>
                                </md-layout>
                                <md-layout md-flex-small="100" md-flex="50" class="container">
                                    <!-- <md-input-container>
                                        <label>Hora (hh:mm)</label>
                                        <md-input type="text" v-model="response.currentDiary.hora"></md-input>
                                    </md-input-container> -->

                                    <md-input-container style="position:relative; top: 14px" class="datepicker--block" :class="{ 'md-input-invalid' : errors.hasOwnProperty('hora') }">
                                        <md-icon style="margin-right: 10px;">access_time</md-icon>
                                        <label>{{translate.pages.tracking.edit.fields.hour}}</label>
                                        <md-select name="hora" id="patient_hora" v-model="response.currentDiary.hora">
                                            <md-option value="08:00">08:00</md-option>
                                            <md-option value="09:00">09:00</md-option>
                                            <md-option value="10:00">10:00</md-option>
                                            <md-option value="11:00">11:00</md-option>
                                            <md-option value="12:00">12:00</md-option>
                                            <md-option value="13:00">13:00</md-option>
                                            <md-option value="14:00">14:00</md-option>
                                            <md-option value="15:00">15:00</md-option>
                                            <md-option value="16:00">16:00</md-option>
                                            <md-option value="17:00">17:00</md-option>
                                            <md-option value="18:00">18:00</md-option>
                                            <md-option value="19:00">19:00</md-option>
                                            <md-option value="20:00">20:00</md-option>
                                            <md-option value="21:00">21:00</md-option>
                                        </md-select>
                                    </md-input-container>
                                </md-layout>
                                <md-layout md-flex-small="100" md-flex="50" class="container">
                                    <md-input-container>
                                        <label>{{translate.pages.tracking.edit.fields.status}}</label>
                                        <md-select id="status" v-model="response.currentDiary.status">
                                            <md-option v-for="state in response.states"
                                                :key="state.id"
                                                :value="state.id">
                                                {{ state.name }}
                                            </md-option>
                                        </md-select>
                                    </md-input-container>
                                </md-layout>
                                <md-layout md-flex-small="100" md-flex="50" class="container">
                                    <md-input-container>
                                        <label>{{translate.pages.tracking.edit.fields.coments}}</label>
                                        <md-input type="text" v-model="response.currentDiary.comment"></md-input>
                                    </md-input-container>
                                </md-layout>
                            </md-layout>
                        </div>
                    </md-dialog-content>
                    <md-dialog-actions class="modal--footer">
                        <md-button class="float-l md-primary md-size sm-size" @click.native="closeDialog('edit')">{{translate.pages.tracking.edit.cancel_btn}}</md-button>
                        <md-button class="float-r md-primary btn--yellow md-size sm-size" @click.native="closeDialog('edit', true)" :disabled="process">{{translate.pages.tracking.edit.edit_btn}}</md-button>
                    </md-dialog-actions>
                </md-dialog>
            </div>
        </div>
    </section>
</template>
<script>
    import { doctor } from '../../config/api.js';
    const swal = require('sweetalert2');
    import moment from 'moment';
    import myDatepicker from 'vue-datepicker/vue-datepicker-es6.vue';
    import { datepicker, options } from '../../config/datepicker.js';
    import VueTimepicker from 'vue2-timepicker';
    export default {
        data() {
            return {
                process: false,
                startDate: { time: ''},
                endDate: { time: ''},
                currentDate: { time: ''},
                option: options,
                limit: [
                    {
                        type: 'fromto',
                        from: moment().subtract(1, "days"),
                        to: ''
                    }
                ],
                offices: [],
                disabledOffice: true,
                data: {
                    office: '',
                    rut: '',
                    name: '',
                    start_date:'',
                    end_date:'',
                },
                currentIndex: -1,
                response: {
                    success: false,
                    data: [],
                    close: false,
                    currentDiary: {
                        patient: {
                            'code': '',
                            'name': '',
                            'lastname': '',
                            'lastname2': '',
                            'phone': '',
                            'email': ''
                        },
                        office: {
                            'name': ''
                        },
                        status: '1'
                    },
                    states: [
                        {id:1,name:'En Espera'},
                        {id:2,name:'En Consulta'},
                        {id:3,name:'Ausente'},
                        {id:4,name:'Cancelada'},
                        {id:5,name:'Reprogramada'},
                        {id:6,name:'Completado'},
                    ]
                },
                errors: {
                    office: {
                        invalid: false,
                        msg: ''
                    },
                    rut: {
                        invalid: false,
                        msg: ''
                    },
                    name: {
                        invalid: false,
                        msg: ''
                    },
                    start_date: {
                        invalid: false,
                        msg: ''
                    },
                    end_date: {
                        invalid: false,
                        msg: ''
                    }
                }
            }
        },
        created() {
            let url = doctor.api.offices;
            let parent = this.$auth.getParent();
            if(parent)
            {
                url += '?parent=' + parent;
            }
            // Get Offices
            this.$http.get(url,{
                        headers: {
                            Authorization : 'Bearer '+ this.$auth.getToken(),
                        }
                }).then(response => {
                    let offices = response.data.data;
                    if(offices.length <= 0)
                    {
                        this.disabledOffice = true;
                    }else{
                        this.disabledOffice = false;
                    }
                    this.offices = offices;
                }).catch(error => {
                    console.log(error);
                    alert("No se pudo cargar consultas");
                });
        },
        computed: {
            // Get Language
            translate(){
                return this.$store.getters.language.app[this.lang].prestador;
            },
            // Get lang
            lang(){
                return this.$store.getters.language.lang;
            }
        },
        methods: {
            // Search
            search() {
                this.data.start_date = this.startDate.time;
                this.data.end_date = this.endDate.time;
                let url = doctor.api.tracking;
                let parent = this.$auth.getParent();
                if(parent)
                {
                    url += '?parent=' + parent;
                }
                this.process = true;
                this.$http.post(url, this.data,{
                        headers: {
                            Authorization : 'Bearer '+ this.$auth.getToken(),
                        }
                }).then(response => {
                    this.process = false;
                    let data = response.data.data;
                    this.response.data = data;
                    this.response.success = true;
                }).catch(error => {
                    console.log(error);
                    this.process = false;
                    swal(this.translate.pages.tracking.swal.search.title, this.translate.pages.tracking.swal.search.message, 'error');
                });
            },
            // Get path
            srcImage(path){
                if(path){
                    return path;
                }
                return 'https://api.agendaenlinea.cl/image/default_avatar.png';
            },
            // Open Modal
            openDialog(ref, row, rowIndex) {
                this.currentIndex = rowIndex;
                this.response.currentDiary = JSON.parse(JSON.stringify(this.response.data[rowIndex]));
                this.currentDate.time = moment(this.response.currentDiary.fecha).format('DD/MM/YYYY');
                this.$refs[ref].open();
            },
            // Close Modal
            closeDialog(ref, save) {
                if(save)
                {
                    this.update(ref);
                }else{
                    this.$refs[ref].close();
                }
            },
            // Show button add
            onSelect(data) {
                this.selectedData = data;
                this.$forceUpdate();
                (_.size(this.selectedData) >= 1) ? this.addButton = false : this.addButton = true;
            },
            // Sort Offices
            onSort(sort) {
                this.response.data = _.orderBy(this.response.data, [item => item[sort.name]], sort.type);
            },
            // Remove Diary
            remove(row, rowIndex){
                swal(this.translate.pages.tracking.swal.remove.title, this.translate.pages.tracking.swal.remove.message, 'warning')
                    .then( () => {
                        let url = '/diary/deletes';
                        let parent = this.$auth.getParent();
                        if(parent)
                        {
                            url += '?parent=' + parent;
                        }
                        this.$http.post(url, {
                                citas: [row.id]
                            }, {
                                headers: {
                                    Authorization : 'Bearer '+ this.$auth.getToken(),
                                }
                            })
                        .then(response => {
                            this.response.data.splice(rowIndex, 1);
                            swal('', response.data.msg, 'success')
                                .then( () => {
                                    //this.$router.push({'name': 'Tracking'});
                                }, (dismiss) => {
                                    //console.log(dismiss);
                                    //this.$router.push({'name': 'Tracking'});
                                });
                        }).catch(error => {
                            console.log(error);
                            alert("Error");
                        });
                    }, (dismiss) => {
                        //console.log(dismiss);
                    });
            },
            // Udpate diary
            update(ref) {
                this.response.currentDiary.fecha = this.currentDate.time;
                let url = doctor.api.diary.update + this.response.currentDiary.id;
                let parent = this.$auth.getParent();
                if(parent)
                {
                    url += '?parent=' + parent;
                }
                this.process = true;
                this.$http.put(url, this.response.currentDiary, {
                            headers: {
                                Authorization : 'Bearer '+ this.$auth.getToken(),
                            }
                    }).then(response => {
                        this.process = false;
                        this.response.data[this.currentIndex] = response.data.data;
                        this.currentOffice = {};
                        this.$refs[ref].close();
                        this.currentIndex = -1;
                        swal('', response.data.msg, 'success');
                    }).catch(error => {
                        this.process = false;
                        alert("error");
                    });
            }
        },
        components: {
            'date-picker': myDatepicker,
            VueTimepicker
        }
    }
</script>
<style lang="stylus" scoped>
    @import '../../assets/styles/variables/color.styl'
    .Tracking
        padding 3em 2em 1em 2em
        .search
            border 1px solid color_form_border
            padding 2em
            .divider
                background color_form_border
                height 1px
                opacity 0.2
                width 100%
            .table
                .img
                    border-radius 50%
                .name
                    margin-left .5em
                .text-center
                    text-align center
                .icon-view
                    cursor pointer
                    font-size 22px
                .icon-edit
                    color color_notifications
                    cursor pointer
                    font-size 22px
                .icon-delete
                    color color_error
                    cursor pointer
                    font-size 22px
                .enabled
                    border 1px solid color_form_placeholder
                    border-radius 30px
                    color color_form_placeholder
                    margin 0 auto
                    padding 3px 4px
                    text-align center
                    width 110px !important
                    &.active
                        border 1px solid color_confirm
                        color color_confirm
        .container
            padding 0.25em 1em
            .suggestion
                bottom .75em
                font-size .85em
                position relative
            .w100
                width 100%
            .w90
                width 90%
            .w10
                width 10%
                margin-top 0
            .span-error
                color #ff5722
            .diary
                bottom: -0.75em
        .button-search
            justify-content flex-end
            .md-primary
                background-color color_main !important
                width 150px
            .md-icon
                padding-left 1em
    .content-main
        .container
            padding 0.25em 1em
    .patient
        padding 1em
        .wrapper
            background #F5F5F5
            border 1px solid color_form_border
            border-radius .25em
    @import '../../../assets/styles/responsive.styl'
</style>



// WEBPACK FOOTER //
// Tracking.vue?8d3c3198